/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * @param Widget Base widget for extending
 * @returns TrackLink Class
 */
function TrackLinkClassCreator(Widget: import('widgets/Widget').TWidget) {
    /**
     * @category widgets
     * @subcategory int_gtm
     * @class TrackLink
     * @augments Widget
     * @classdesc TrackLink widget, which used to track click action on links for GTM
     * @property {string} data-widget - Widget name `trackLink`
     * @property {string} data-event-click - Event listener method `handleClick` for click event on widget
     * @property {string} data-event-name - Event name or default `trackLink.clicked` to emit on click
     * @property {object} data-event-payload - Event payload or event element by default
     *
     * @example <caption>Example of TrackLink widget usage</caption>
     *  <p class="b-promo_line-inner"> A collection just for our members.
     *      <a data-widget="trackLink"
     *         data-event-click="handleClick"
     *         href="$url('Search-Show', 'cgid', 'womens')$"
     *      >
     *         Shop Now
     *      </a>
     *  </p>
     */
    class TrackLink extends Widget {
        prefs() {
            return {
                eventName: '',
                eventPayload: null,
                ...super.prefs()
            };
        }

        /**
         * @description Handles link click
         * @listens dom:click
         * @emits trackLink.clicked
         */
        handleClick(el: HTMLElement) {
            const eventName = this.prefs().eventName || 'trackLink.clicked';
            const payload = this.prefs().eventPayload || el;

            this.eventBus().emit(eventName, payload);
        }
    }

    return TrackLink;
}

export type TTrackLink = ReturnType<typeof TrackLinkClassCreator>;

export type TTrackLinkInstance = InstanceType<TTrackLink>;

export default TrackLinkClassCreator;
